import React, { useEffect } from 'react';
import { useParams, Link } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import AOS from 'aos';
import 'aos/dist/aos.css';

function MarkaDetay() {
  const { markaSlug } = useParams();
  
  // URL'den verileri ayıklıyoruz
  const parcalar = markaSlug.split('-');
  const rawMarka = parcalar[0];
  const asilMarka = rawMarka.charAt(0).toUpperCase() + rawMarka.slice(1);
  const isKombi = markaSlug.includes('kombi');
  const kategoriAdi = isKombi ? 'Kombi' : 'Beyaz Eşya';

  // AOS VE DİNAMİK BAŞLIK AYARI
  useEffect(() => {
    // Sayfa başlığını zorla güncelliyoruz
    document.title = `${asilMarka} ${kategoriAdi} Servisi Ankara | 7/24 Teknik Destek`;

    window.scrollTo(0, 0);
    AOS.init({
      duration: 800,
      easing: 'ease-in-out',
      once: true,
    });
  }, [markaSlug, asilMarka, kategoriAdi]);

  // SAĞ MENÜ (BACKLİNK) İÇİN MARKA LİSTELERİ
  const digerKombiMarkalari = [
    { isim: 'Vaillant', url: 'vaillant-kombi' }, { isim: 'Viessmann', url: 'viessmann-kombi' },
    { isim: 'Buderus', url: 'buderus-kombi' }, { isim: 'Bosch', url: 'bosch-kombi' },
    { isim: 'Demirdöküm', url: 'demirdokum-kombi' }, { isim: 'Baymak', url: 'baymak-kombi' },
    { isim: 'E.C.A.', url: 'eca-kombi' }
  ];

  const digerBeyazEsyaMarkalari = [
    { isim: 'Arçelik', url: 'arcelik-beyaz-esya' }, { isim: 'Beko', url: 'beko-beyaz-esya' },
    { isim: 'Siemens', url: 'siemens-beyaz-esya' }, { isim: 'Vestel', url: 'vestel-beyaz-esya' },
    { isim: 'Samsung', url: 'samsung-beyaz-esya' }, { isim: 'Bosch', url: 'bosch-beyaz-esya' },
    { isim: 'LG', url: 'lg-beyaz-esya' }
  ];

  const gosterilecekMenuler = isKombi ? digerKombiMarkalari : digerBeyazEsyaMarkalari;
  const ilceler = ["Keçiören", "Altındağ", "Mamak", "Çankaya", "Pursaklar", "Yenimahalle", "Eryaman", "Sincan"];
  const metaKeywords = `${asilMarka} ankara teknik servis, ankara ${asilMarka} servisi, ${asilMarka} yetkili servis, ankara ${kategoriAdi.toLowerCase()} servisi, ` + ilceler.map(ilce => `${asilMarka} ${ilce} servisi, ${asilMarka} ${ilce} teknik servis`).join(', ');

  // --- GOOGLE İÇİN DİNAMİK MARKA SERVİS ŞEMASI ---
  const markaSchema = {
    "@context": "https://schema.org",
    "@type": "Service",
    "name": `${asilMarka} ${kategoriAdi} Teknik Servisi`,
    "provider": {
      "@type": "LocalBusiness",
      "name": "Ankara Merkez Teknik",
      "telephone": "+903125810881"
    },
    "areaServed": {
      "@type": "City",
      "name": "Ankara"
    },
    "description": `Ankara genelinde ${asilMarka} marka ${kategoriAdi} cihazlarınız için 7/24 garantili tamir, bakım ve orijinal yedek parça hizmeti.`
  };

  return (
    <div className="marka-page-wrapper">
      <Helmet>
        <title>{asilMarka} {kategoriAdi} Servisi Ankara | Ankara Merkez Teknik</title>
        <meta name="description" content={`Ankara'da garantili ve 7/24 ${asilMarka} marka ${kategoriAdi} teknik servis, bakım ve onarım hizmeti. Sincan, Yenimahalle, Çankaya dahil tüm ilçelerdeyiz.`} />
        <meta name="keywords" content={metaKeywords} />
        <script type="application/ld+json">
          {JSON.stringify(markaSchema)}
        </script>
      </Helmet>

      {/* --- HERO BANNER --- */}
      <div className="marka-hero-banner" data-aos="fade-in">
        <h1 data-aos="zoom-in" data-aos-delay="200">{asilMarka} {kategoriAdi} Teknik Servisi</h1>
        <p data-aos="fade-up" data-aos-delay="400">Ankara Merkez Teknik güvencesiyle aynı gün, orijinal yedek parça garantili profesyonel müdahale.</p>
      </div>

      <div className="marka-container">
        {/* SOL TARAF */}
        <main className="marka-main-content" data-aos="fade-right">
          <h2>Neden {asilMarka} Cihazlarınız Bize Emanet?</h2>
          <p>
            Yılların verdiği tecrübe ile <strong>{asilMarka} marka {kategoriAdi}</strong> modellerinde kronikleşmiş arızaları, bakım gereksinimlerini ve montaj aşamalarını ezbere biliyoruz. Orijinal yedek parça kullanımı ve profesyonel işçiliğimiz ile cihazlarınızın ömrünü uzatıyoruz. 
          </p>

          <div className="service-features">
            <div className="feature-box" data-aos="fade-up" data-aos-delay="100">
              <h4>Aynı Gün Servis</h4>
              <p>Ankara'nın neresinde olursanız olun, gezici ekiplerimizle arızalara anında müdahale ediyoruz.</p>
            </div>
            <div className="feature-box" data-aos="fade-up" data-aos-delay="200">
              <h4>1 Yıl Parça Garantisi</h4>
              <p>Değiştirdiğimiz tüm <strong>{asilMarka}</strong> orijinal yedek parçaları 1 yıl firmamız garantisi altındadır.</p>
            </div>
          </div>

          <h3>Sık Karşılaşılan {asilMarka} Arızaları</h3>
          <p>
            {isKombi ? 
              `${asilMarka} kombilerde sıkça görülen su akıtma, peteklerin ısınmaması veya sıcak su vermeme gibi sorunlar ekiplerimiz tarafından bilgisayarlı cihazlarla dakikalar içinde tespit edilir.` : 
              `${asilMarka} marka buzdolaplarında soğutmama, çamaşır makinelerinde su boşaltmama veya sesli çalışma gibi teknik sorunlar uzman kadromuz tarafından yerinde onarılır.`
            } 
          </p>

          <div className="seo-keyword-box" data-aos="fade-up">
            <h4>📍 Ankara {asilMarka} Geniş Servis Ağımız</h4>
            <p>
              Ankara Merkez Teknik olarak şehrin dört bir yanına hizmet ulaştırıyoruz. Özellikle <strong>{asilMarka} Ankara teknik servis</strong> arayışlarınızda hızlı çözüm sunuyoruz. <strong>{asilMarka} Keçiören servisi</strong>, <strong>{asilMarka} Altındağ teknik servis</strong>, <strong>{asilMarka} Mamak teknik servis</strong> ve <strong>{asilMarka} Çankaya servisi</strong> ekiplerimiz aralıksız devriye atmaktadır. 7/24 kesintisiz <strong>Ankara {kategoriAdi.toLowerCase()} servisi</strong> ve bakımı için bize her saat ulaşabilirsiniz.
            </p>
          </div>
        </main>

        {/* SAĞ TARAF */}
        <aside className="marka-sidebar" data-aos="fade-left">
          <div className="sidebar-widget">
            <h3>Diğer {kategoriAdi} Markaları</h3>
            <div className="sidebar-links">
              {gosterilecekMenuler.map((item, index) => (
                <Link 
                  key={index} 
                  to={`/marka/${item.url}`} 
                  className={item.url === markaSlug ? 'active-link' : ''}
                >
                  {item.isim} Servisi <span>→</span>
                </Link>
              ))}
            </div>
          </div>

          <div className="sidebar-widget contact-widget">
            <h3>Hızlı Destek Hattı</h3>
            <p>Arızanızı anlatın, uzman ustalarımız hemen kapınıza gelsin.</p>
            <a href="tel:03125810881" className="btn-white">📞 0312 581 08 81</a>
          </div>
        </aside>
      </div>
    </div>
  );
}

export default MarkaDetay;